import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./copyright.component.scss']
})
export class CopyrightComponent {
  @Input() showStrong = true;
  currentYear = new Date().getFullYear();
}
